// Update these keys to match the exact permission names used in your backend.
export const DASHBOARD_PERMISSION_KEYS = {
  listing: [
    'LISTING',
    'LISTINGS',
    'LISTING_SUMMARY',
    'LISTING_COUNT',
    'MARKET_LISTING',
    'OFFER',
    'DEMAND',
  ],
  bids: ['BID', 'BIDDING'],
  vendors: ['VENDOR', 'TRADER'],
  orders: ['ORDER', 'ORDER_SUMMARY'],
  history: ['HISTORY', 'GRADE_TOUCH', 'GRADE_HISTORY'],
  orderStatus: [
    'ORDER_STATUS',
    'ORDER_COUNTS_BY_STATUS',
    'ORDER_SUMMARY',
    'ORDER',
  ],
  notifications: [
    'SEE_DASHBOARD_NOTIFICATIONS',
    'DASHBOARD_NOTIFICATIONS',
    'DASHBOARD_NOTIFICATION',
  ],
  tasks: [
    'SEE_DASHBOARD_TASKS',
    'SEE_DASHBOARD_TASK',
    'DASHBOARD_TASKS',
    'DASHBOARD_TASK',
  ],
};
